import store from "../../redux/store"; 

export function getEksConfig(store) {
    let isEksEnabled = false;
    let eksEndpoints = [];
    if (store) {
      const state = store.getState();
      return { 
        isEksEnabled: state.auth?.is_eks_enabled || false, 
        eksEndpoints: state.auth?.eksEndpoints || [] 
      };
    }
    return { isEksEnabled, eksEndpoints };
} 